import { render, staticRenderFns } from "./standardizationNotification.vue?vue&type=template&id=363f4c7b&scoped=true&"
import script from "./standardizationNotification.vue?vue&type=script&lang=js&"
export * from "./standardizationNotification.vue?vue&type=script&lang=js&"
import style0 from "./standardizationNotification.vue?vue&type=style&index=0&id=363f4c7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f4c7b",
  null
  
)

export default component.exports